var _defs, _circle, _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcsmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2f2f2f;\n        stroke: #2f2f2f;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.5,
    cy: 26.5,
    r: 22.5
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Icon_Line_16",
    "data-name": "Icon Line_16",
    x: 12,
    y: 12,
    width: 29,
    height: 28,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAcCAYAAACdz7SqAAADHElEQVRIib2WXWiWZRjHf/P1gzXFjwzSSl15piKFtNJh62AURYKgBgohip6IgkdBoWIp6EEHSmd+44k6MWyBHpSiQWfK1JNprgiTETmZWpubc3+58j+99/i+7553hBfc73O/z31d1//6vh8k5VnVkjZJuiCpS1KnpJ8kLcspP2hVxc8QtBI4YJYWrzHAO0At8BfQALQOpegJDWHVV3pMuyUVipy/LqnFPHV5PS13+LGVrc2h6JR5myXtkbRguKB9kn6pIFenJbVbLuiSpGmVgNZZsHY4hWJPb1rHjLygOy0wHMB0hecdeUDrDXjnfwCdYl2DWmtkppj3AquBs8Dm5P0LQB0wokwj9AHnMu/agR+Ao5Y98t/bxIJmW7U4Y+1iPaV/PRy6k9Xl90G9kuYV8fgbn69SMhy+ALYDb7r5B2ga8AewD9jqIRCDoT/hCQ+6gDPAMWA+MBG4l/F6B/A5MD2sqLEV3xax8MukoJoSb7JLHiSTvP+oRI4jIpcjp5/Zkg1F8hRe/AlsAZY4Et1AVcITXr8G/AjcBnqB6hJ5Xx9RC9BPgKuZkA3QAwPUADczoU/pGvC7w9pvuWLUFKDhyRtAWwkmDNoDz1R6SuMdlZ5MFLIUeX4QjHct9DwoDC8E6HngrecEOiciEqAHnfiGIkydti5CVu7i7fd58BWAv0vw7cQKrwAXPYUarCCEHzoCd4BxwKgyoPc8tards+87xwWfP/SF3wisGxgOE4BfgckGHWHGEPrZLRPNf9JGpMUSCmYAC4G3ge+BlxN5kv1xYOlARUYYXwJeTJSF4g+Bw8Alz96N9kgZvphaUz3BArDebaiEp884ub6Rojfnenj8BsyyklA6xZV/GZjtnMUo/LSsxpxX1O5kqF+X1Or9P8m+R9LmPPoquRvfy1zsAdjofdDyvLrK3Y/vAl97tAXd93Nskqe0BnqT/TZgUaXhnZncoXclfSepzf/HJN5tSPa3JJ2QdMOhLnnblPJ0tJ9RcdGjUSQdwBrP16Bd7u+gD/yxHXyvuleDQraiQlohab+kuRV+F70i6VAShcFL4hFzDzHn4iJdXAAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcsmall);
export default __webpack_public_path__ + "static/media/ccsmall.2bd851f2.svg";
export { ForwardRef as ReactComponent };